import PropTypes from 'prop-types';
import React from 'react';
import IconButton from 'common/display/Profile/components/IconButton';

export function StructuredInteractionsHeader({
  title,
  labelText,
  onClick,
  disabled,
}) {
  return (
    <div className="mb-4 grid grid-cols-[minmax(0,9fr)_minmax(0,3fr)] items-center gap-x-4">
      <h2 className="m-0 min-w-0 w-full p-0 text-left">{title}</h2>
      <div className="min-w-0 justify-self-end" data-testid="structured-interaction-add">
        <IconButton
          className="text-right"
          id="add-structured-interaction-button"
          icon="Add"
          labelText={labelText}
          onClick={onClick}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

StructuredInteractionsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

StructuredInteractionsHeader.defaultProps = {
  disabled: false,
};
